/* eslint-disable import/prefer-default-export */
import React from 'react';

import RIQButton from '../../../../components/RIQButton.jsx';
import useCDNUrl from '../../../../hooks/useCDNUrl.js';

export function ChannelAuthWidget(privateMetadata, source) {
    let tokenStatus = `emptyToken`;

    if (_.get(privateMetadata, ['sources', source.source, 'validToken'])) {
        if (_.isEmpty(privateMetadata.companies)) {
            tokenStatus = `emptyLandscapeToken`;
        } else {
            tokenStatus = `validLandscapeToken`;
        }
    }

    let noAccessImage;
    const sadGraphs = useCDNUrl('/images/sad_graphs.png');
    const redactedChannel = useCDNUrl(`/images/${source.channel}-auth.svg`);
    let noAccessMessage = '';
    let connectButton = '';

    if (tokenStatus === 'emptyToken') {
        noAccessImage = redactedChannel;
        noAccessMessage = `Authorize ${source.name} access to view fans, reach, and consumption data.`;
        connectButton = `Connect to ${source.name}`;
    }
    if (tokenStatus === 'emptyLandscapeToken') {
        noAccessImage = sadGraphs;
        noAccessMessage = `You don't have access to ${source.name} analytics for any company in this landscape.`;
        connectButton = `Manage ${source.name} Connections`;
    }

    if (tokenStatus === 'emptyToken' || tokenStatus === 'emptyLandscapeToken') {
        return InvalidToken(noAccessImage, noAccessMessage, connectButton);
    }
}

function InvalidToken(noAccessImage, noAccessMessage, connectButton) {

    return (
        <div className='tlw-mb-10 tlw-flex tlw-flex-col tlw-rounded'>
            <div className='tlw-grid tlw-grid-cols-1 tlw-p-8'>
                <img
                    className='tlw-m-auto tlw-mt-4 tlw-max-w-[600px] tlw-items-center'
                    style={{
                        width: '50%'
                    }}
                    alt='error'
                    src={noAccessImage}
                />
                <span className='tlw-mb-10 tlw-mt-12 tlw-text-center tlw-text-lg tlw-font-normal'>{noAccessMessage}</span>
                <div className='tlw-flex tlw-items-center tlw-justify-center tlw-border-0'>
                    {/** currently, we use button variants/colors _per_channel_ see public/stylesheets/rivaliq/components/buttons.less */}
                    <RIQButton
                        className='tlw-mx-4 tlw-w-[300px] tlw-px-6 tlw-py-3'
                        variant='primary'
                        onClick={onClickConnectAccount}
                    >
                        {connectButton}
                    </RIQButton>
                </div>
            </div>
        </div>
    );
}

// tiktok is the only channel using this widget currently, and for now, it's being directed to the connected accounts page
// the multiTokenConnectionModal will be attached here
function onClickConnectAccount() {
    RivalIQ.execute('history:navigate', 'account/services', {
        trigger: true
    });
}
